import Cabrio from '@allesauto/design/graphics/Cabrio.svg';
import CarDefaultIcon from '@allesauto/design/graphics/Car-Default.svg';
import Gelaendew_PickUp from '@allesauto/design/graphics/Gelaendew_PickUp.svg';
import Kleinwagen from '@allesauto/design/graphics/Kleinwagen.svg';
import Kombi from '@allesauto/design/graphics/Kombi.svg';
import Limousine from '@allesauto/design/graphics/Limousine.svg';
import CommercialVehicle from '@allesauto/design/graphics/Nutzfahrzeug.svg';
import Sportwagen from '@allesauto/design/graphics/Sportwagen.svg';
import VanMinibus from '@allesauto/design/graphics/Van-Minibus.svg';
import { getSlug } from '@allesauto/utils/funcs';
import { isAuregoShop } from '@allesauto/utils/funcs.ts';
import clsx from 'clsx';
import React, { FC, useEffect, useState } from 'react';

import { useWhiteLabel } from '../whiteLabel';

export interface VehicleIconProps {
  onClick: (color: string, added: boolean) => any;
  isDefaultActive?: boolean;
  displayName: string;
  name: string;
}

// Map BE keys to FE icons
const VehicleIconList: any = {
  SportsCar: Sportwagen,
  Cabrio: Cabrio,
  SmallCar: Kleinwagen,
  EstateCar: Kombi,
  Limousine: Limousine,
  OffRoad: Gelaendew_PickUp,
  Van: VanMinibus,
  CommercialVehicle: CommercialVehicle,
};

const VehicleIcon: FC<VehicleIconProps> = (props: VehicleIconProps) => {
  const { onClick, isDefaultActive = false, displayName, name } = props;
  const [active, setActive] = useState(isDefaultActive || false);
  const trackingIdentifier = `aa-filter--vehicle-type-${getSlug(name)}`;
  const whiteLabel = useWhiteLabel();

  const className = {
    container: clsx('group max-h-[165px] max-w-[100px] mb-30px'),
    squareContainer: clsx(
      `aspect-square cursor-pointer flex items-center justify-center rounded-default ${
        isAuregoShop(whiteLabel) && 'aurego-border'
      }`,
      active
        ? `${
            whiteLabel
              ? 'monochrome:bg-grey90 monochrome:border-grey90 border-3px'
              : 'bg-green60 border-green60 monochrome:bg-grey10  monochrome:border-grey10 border-3px'
          }`
        : `${
            isAuregoShop(whiteLabel)
              ? 'border-white border-1px monochrome:group-hover:!border-grey90 group-hover:border-green60 group-hover:!border-3px'
              : 'border-white border-1px monochrome:group-hover:border-grey10 group-hover:border-green60 group-hover:border-3px'
          }`
    ),
    squareDiv: clsx(
      ' rounded-[2px] squareDiv',
      active
        ? `monochrome:bg-grey10 rounded-none ${whiteLabel && '!bg-transparent'}`
        : 'monochrome:group-hover:border-green10 group-hover:border-green60 group-hover:rounded-none'
    ),
    vehicleStyle: clsx(
      'h-[25px] max-h-[25px] place-content-center',
      active
        ? `text-purple80${
            isAuregoShop(whiteLabel)
              ? '!text-white monochrome:!text-white'
              : 'monochrome:text-grey90 '
          }`
        : 'text-white group-hover:text-green60 monochrome:group-hover:text-grey10'
    ),
    displayText: clsx(
      'font-normal leading-5 max-w-[100px] mt-5px overflow-hidden text-center text-ellipsis text-p2',
      active
        ? `text-green60 ${
            isAuregoShop(whiteLabel)
              ? 'monochrome:text-grey90'
              : 'monochrome:text-grey10'
          } font-weight-bold`
        : 'text-white font-weight-normal monochrome:group-hover:text-grey10 group-hover:font-weight-bold group-hover:text-green60'
    ),
  };
  const { squareDiv, vehicleStyle, container, displayText, squareContainer } =
    className;

  const onColorClick = () => {
    setActive(!active);
    onClick(name, !active);
  };

  useEffect(() => {
    setActive(isDefaultActive);
  }, [isDefaultActive]);

  const VehicleIconDisplay = (name && VehicleIconList[name]) || CarDefaultIcon;
  return (
    <div className={container}>
      <div
        className={squareContainer}
        data-tracking-id={trackingIdentifier}
        onClick={onColorClick}
      >
        <div className={squareDiv}>
          {VehicleIconDisplay && (
            <VehicleIconDisplay className={vehicleStyle} />
          )}
        </div>
      </div>
      <p className={displayText}>{displayName}</p>
    </div>
  );
};

export default VehicleIcon;
